
<template>
    <div class="form-block">
        <div>
            <h2 class="form-block__title mb-3">{{title_form}}</h2>
            <div v-show="step === 1" class="form-block_body">
                <div class="black_block mb-3">
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Report name</div>
                        <input v-model="model.name" type="text" class="form-control" :class="{'is-invalid': error_name}">
                        <div @click="model.name = ''" class="btn-close btn-close-rel"></div>
                    </div>
                </div>

                <div v-show="(crud != 'update')" class="black_block mb-3">
                    <h5>Choose time period:</h5>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Global time (begin)</div>
                        <input v-model="model.date_begin" type="datetime-local" class="form-control" :class="{'is-invalid': error_name}">
                        <div @click="model.date_begin = ''" class="btn-close btn-close-rel"></div>
                    </div>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Global time (end)</div>
                        <input v-model="model.date_end" type="datetime-local" class="form-control" :class="{'is-invalid': error_name}">
                        <div @click="model.date_end = ''" class="btn-close btn-close-rel"></div>
                    </div>
                </div>

                <div v-show="(crud != 'update')" class="black_block" style="max-height: 220px;overflow: auto;">
                    <h5>Choose video: {{ check_video }}</h5>
                    <hr>
                    <!-- <div class="wrapper_scroll_table"> -->
                    <div>
                        <table class="table fz09">
                            <tr v-for="video in videosItem">
                                <td class="p-lr-0 p-tb-5">
                                    <div class="d-flex position-relative">
                                        <input v-model="video.checked" @change="checkVideo" :id="`video_${video.id}`" :value="video.id" type="checkbox" class="custom_checkbox">
                                        <label :for="`video_${video.id}`">{{video.name}}</label>
                                    </div>
                                </td>
                                <td></td>
                                <td>{{video.description}}</td>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>



            <div v-show="step === 2" class="form-block_body">
                <div class="black_block">
                    <h5>Add persons:</h5>
                    <div class="input_search input_search_border mt-3">
                        <input v-model="restPersonsParams.name" @keypress.enter="findname" type="text" placeholder="Search" class="form-control">
                        <svg @click="findname" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
                        </svg>
                    </div>

                    <!-- <div class="wrapper_scroll_table"> -->

                        <div>
                        
                        <div class="rpersons-cards_wrap">
                        <table class="table mt-3 fz09">                            
                            <tr class="border-bottom">
                                <th class="d-flex justify-content-start p-lr-0 p-tb-5">
                                    <input id="all" type="checkbox" class="custom_checkbox">
                                    <label for="all"></label>
                                    <span @click="sortName" class="cursor_pointer">
                                    <iconsort :updown="sort_name"></iconsort>
                                    <span>Name {{check_person}}</span>
                                </span>
                                </th>
                                <th class="p-lr-0 p-tb-5">ID</th>
                                <th></th>
                            </tr>
                            
                            
                                <tr v-for="person in personsItem">
                                    <td class="p-lr-0 p-tb-5">                                    
                                        <input v-model="person.checked" @change="checkPerson(person)" :id="`person_${person.id}`" type="checkbox" class="custom_checkbox">
                                        <label :id="`label_${person.id}`" :for="`person_${person.id}`">{{ person.first_name }} {{ person.last_name }}</label>
                                    </td>
                                    <td class="p-lr-0 p-tb-5">{{ person.id }}</td>
                                    <td></td>
                                </tr>
                            


                        </table>
                        </div>
                    </div>

                </div>
            </div>






        </div>
        <div class="form-block__footer d-flex justify-content-between">
            <div class="form-block__footer_left d-flex justify-content-start align-items-end">
                <button v-show="step === 2" @click="setStep(1)" class="btn btn-link margin-r4">Step back</button>
            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>
                <button v-show="(step === 1) && (crud == 'create')"  @click="setStep(2)" class="btn btn-primary">Next step</button>
                <button v-show="(step === 2) || (crud == 'update')"  @click="sendReport" class="btn btn-primary">{{ text_submit }}</button>                
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from '../../bus';
import iconsort from "../iconsort";
import axios from "axios";
import Vue from 'vue';

export default {
    props: ['prop_titleform', 'crud', 'data'],
    data(){
        return{
            title_form: '',
            text_submit: 'Create',
            model: {
                name: '',
                date_end: '',
                date_begin: '',
                persons: [],
                videos: [],
            },
            persons: [],
            videos: [],
            error_name: false,
            step: 1,
            sort_name: 'up',
            check_video: [268],
            check_person: [],
            check_person_uuids: [],
            model_find: '',
            restPersonsParams: {
                countitempage: 15,
                step: 10,
                sort: 'first_name',
                sorttype: 'asc',
                find: '',
                page: 1,
                name: '',
                listtype: 'reportform'
            },
            waitingForAnResponse: false,
            restPersons: []            
        }
    },
    methods: {
        findname(){
            this.getPersons();            
        },
        getVideos(){
            axios.get('/videoall',
                {
                    headers: {
                        'ContentType': 'application/json'
                    }
                }).then((response) => {

                    console.log('response.data get videos: ', response.data);

                    this.videos = response.data;

                    this.selectVideo();

            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
        getPersons(){
            let params = this.restPersonsParams;
            
            const url = `/persons`;
            
            axios.get(
                url,            
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }                
            )           
            .then((response) => {
                this.persons = response.data.data;

                console.log('this.persons uploads: ', this.persons);
                
                let countPersons = this.persons.length;
                this.changePageProp = false;
                this.waitingForAnResponse = false;

                console.log('response.data from get persons in create report: ', response.data);
                                
                this.persons.map((item, key) => {
                    if( this.check_person.includes(item.id) )
                        item.checked = true;
                });
                
                
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
        scroll() {               
            // let listRpersons = document.querySelector('.wrapper_scroll_table');

            
            let listRpersons = document.querySelector('.rpersons-cards_wrap');

            
            console.log('listRpersons: ', listRpersons);
            
            listRpersons.onscroll = () => {
                
                console.log('persons scroll');
                
                /*
                    clientHeight высота содержимого вместе с полями padding, но без полосы прокрутки.
                    offsetHeight «внешняя» высота блока, включая рамки.
                    scrollHeight полная внутренняя высота, включая прокрученную область.
                */                
                let bottomOfListRpersons =
                    listRpersons.scrollTop + listRpersons.clientHeight + 10 >=
                    listRpersons.scrollHeight;
                /* listRvideos.scrollHeight > 40 because otherwise it reacts to decreasing height when clearing the list
                    40 random approximate number */
                
                
                if (
                    bottomOfListRpersons && listRpersons.scrollHeight > 40
                    && 
                    !this.waitingForAnResponse
                ) {                    
                    this.loadingDataFromServer()
                }
            };
        },
        loadingDataFromServer() {                
            this.waitingForAnResponse = true    // flag for not reppeat before respons from server
            this.isLoad = true  // enable "Loading..." down list            
            this.restPersonsParams.countitempage += this.restPersonsParams.step;            
            let response = this.getPersons();
            // this.isLoad = false
        },
        checkPerson(person){
            console.log('person.checked: ', person.checked);
            this.persons.map((item, key) => {                
                if(item.id == person.id){
                    if(item.checked){
                        this.check_person.push(item.id);
                        this.check_person_uuids.push(item.uuid);
                    } else {                        
                        let idInd = this.check_person.indexOf(item.id),
                            uuidInd = this.check_person_uuids.indexOf(item.uuiid);
                        this.check_person.splice(idInd, 1);
                        this.check_person_uuids.splice(uuidInd, 1);
                    }
                }                
            });                        
            console.log('this.check_person: ', this.check_person);
            console.log('this.check_person_uuids: ', this.check_person_uuids);
            
            // this.check_person = [];
            // this.check_person_uuids = [];
            
            
            // this.persons.map((item, key) => {
                
            //     // if(item.id == 2377){
            //     //     console.log('item.checked in iteration: ', item.checked);
            //     // }
                
            //     if(item.checked){
                    
            //         console.log(`person ${person.id} checked`);
                    
            //         this.check_person.push(item.id);
            //         this.check_person_uuids.push(item.uuid);                    
            //     }
            // });

            // console.log('this.check_person: ', this.check_person);


            // console.log('*********************************************************');
            
        },
        clearinput(id){
            if(id === 'name'){
                this.model.name = '';
            }
        },
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        setStep(id){
            this.step = id;
            if(this.step == 2){
                this.getPersons();
                this.scroll();
            }
                
        },
        sendReport(){
            if(this.validform()){
                if(this.crud === 'create'){
                    this.addReport();
                    this.closePopup();
                    // bus.$emit('addreport', this.model);
                }
                if(this.crud === 'update'){
                    console.log('update report');
                    this.updateReport();
                    this.closePopup();
                    // bus.$emit('editreport', this.model);
                }
            }
        },
        addReport(){
            console.log('this.model.date_begin', this.model.date_begin);
            console.log('this.model.date_end', this.model.date_end);
            axios.post( 
                '/reports',                
                {
                    name: this.model.name,
                    video_id: this.check_video,
                    person_uuid: this.check_person_uuids,
                    date_begin: this.model.date_begin,
                    date_end: this.model.date_end,
                },
                {
                    headers: {                        
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    onUploadProgress: (progressEvent) => {
                        let progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        this.videos[id].progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        if(progress === 100){
                            this.videos[id].done = true;
                        }
                    }
                }
            ).then((responce)=>{
                console.log(responce);                
                if(responce.data.front_id){
                    this.videos[id].id = responce.data.id;
                    this.videos[id].date = hVue.convertTimestamp(responce.data.date);
                }
                bus.$emit('updatereports');
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        updateReport(){
            console.log('this.model.name', this.model.name);
            axios.put( `/reports/${this.model.id}`,
                {
                    name: this.model.name                    
                }
            ).then((response)=>{
                console.log('update report', response);
            }).catch(function(error){
                console.log('FAILURE Report!!');
                console.log(error);
            });

        },
        sortName(){

            if(this.sort_name === 'up'){
                this.sort_name = 'down';
            }else{
                this.sort_name = 'up';
            }
        },
        validform(){

            this.error_name = false;

            if(this.model.name === ''){
                this.error_name = true;
                return false;
            }

            return true;

        },       
        checkVideo(){
            this.check_video = [];
            this.videos.map((item, key) => {
                if(item.checked){
                    this.check_video.push(item.id);
                }
            });
        },
        selectVideo(){
            console.log('start selected video');
            if(this.model.videos.length > 0){
                this.model.videos.map((item) => {
                    this.videos.map((item2 => {
                        if(item2.id === item.id){
                            item2.checked = true;
                            console.log('selected video', item.id, item2.id)
                        }
                    }));
                });
            }
            console.log('finish selected video', this.videos);
            this.checkVideo();
        },
        selectPerson(){
            console.log('start person video');
            if(this.model.persons.length > 0){
                this.model.persons.map((item) => {
                    this.persons.map((item2 => {
                        if(item2.id === item.id){
                            item2.checked = true;
                            console.log('selected person', item.id, item2.id)
                        }
                    }));
                });
            }
            console.log('finish person video', this.Pesons);
            this.checkPerson();
        }
    },
    mounted(){
        this.getVideos();
        // this.getPersons();
        this.checkVideo();
        // this.scroll();
        if(this.data){
            this.model = this.data;
        }        
        if(this.crud === 'create'){
            this.title_form = 'Create new report';
            this.text_submit = 'Create';
        }
        if(this.crud === 'update'){
            this.title_form = 'Edit';
            this.text_submit = 'Done';
        }
    },
    components: {
        iconsort
    },
    computed: {
        videosItem(){
            this.videos.map((item) => {
                // item.checked = false;
                item.opensetting = false;
            });
            return this.videos;
        },
        personsItem(){
            this.persons.map((item) => {                
                item.opensetting = false;
            });
            return this.persons;
        }
    },
}
</script>

<style scoped lang="scss">
    .rpersons-cards_wrap {
        overflow: auto;
        height: 320px;
    }
    .popup {
        height: 50vh;
    }
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
